<template>
  <div class="rms-order-food">
    <a-spin :spinning="loading">
      <a-layout style="height:calc(100vh - 125px)">
        <a-layout-sider style="background:#fff;" :width="550">
          <div class="rms-order-wraper">
            <div class="rms-order-info">
              <div class="rms-order-header">
                <div class="text-cell-group">
                  <div class="text-cell-item">
                    <label>开单时间：</label>
                    <span>{{ orderData.CheckInTime }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>人数：</label>
                    <span>{{ orderData.PersonCount }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>联系人：</label>
                    <span>{{ orderData.Contact }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>电话：</label>
                    <span>{{ orderData.Phone }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>业务员：</label>
                    <span>{{ orderData.SalesmanName }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>单号：</label>
                    <span>{{ orderData.No }}</span>
                  </div>
                </div>
              </div>
              <div class="rms-order-table">
                <data-grid
                  ref="orderTable"
                  size="middle"
                  :columns="orderColumns"
                  v-model="orderFoodList"
                  :pagination="false"
                  :props="orderTableProps"
                  :scroll="tableScroll"
                  :locale="{ emptyText: '请选择右侧菜品点菜' }"
                  rowKey="_id"
                  @selectRow="onOrderTableSelectedRow"
                >
                  <template slot="name" slot-scope="text, row">
                    <div class="food-title multi-line" style="text-align:left;">
                      <div>
                        <span class="icon-list">
                          <i
                            v-if="row.Id"
                            class="icon-text"
                            style="background:rgb(135, 208, 104);color:#fff;"
                            ><a-icon type="check"
                          /></i>
                          <i
                            v-if="!row.Id"
                            class="icon-text"
                            style="background:#1890ff;color:#fff;"
                            ><a-icon type="plus"
                          /></i>
                          <a-popover placement="bottomLeft" title="套餐菜品">
                            <template slot="content">
                              <div
                                v-for="foodItem in row.PackDetails"
                                :key="foodItem.Id"
                                class="flex"
                              >
                                <div class="flex-item">{{ foodItem.Name }}</div>
                                <div>{{ foodItem.Quantity }}</div>
                              </div>
                            </template>
                            <i
                              v-if="row.IsPack"
                              class="icon-text"
                              style="background:#f90;color:#fff;cursor: pointer;"
                              >套</i
                            >
                          </a-popover>
                        </span>
                        {{ text }}
                      </div>
                      <div
                        v-if="row.PracticeDesc || row.CookingMethodDesc"
                        class="text-less"
                      >
                        「做法」{{ row.PracticeDesc
                        }}{{ row.CookingMethodDesc }}
                      </div>
                    </div>
                  </template>
                </data-grid>
                <div v-if="showFoodCookingMethod" class="cooking-method quick">
                  <ul>
                    <li
                      v-for="item in foodCookingMethod"
                      :key="item.Id"
                      :class="[
                        {
                          check:
                            currentSelectedRow &&
                            currentSelectedRow.CookingMethodIds &&
                            currentSelectedRow.CookingMethodIds.includes(
                              item.Id
                            )
                        }
                      ]"
                      @click="onFoodCookingMethodClick(item)"
                    >
                      {{ item.Text }}
                      <a-icon type="check" class="check-icon" />
                    </li>
                    <li @click="addMethod">
                      手写
                    </li>
                    <li
                      v-if="
                        foodCookingMethodAll && foodCookingMethodAll.length > 4
                      "
                      @click="openMoreFoodCookingMethodModal"
                    >
                      更多
                    </li>
                  </ul>
                  <a
                    class="cooking-method-close_button"
                    @click="closeCookingMethodBox"
                  >
                    <a-icon type="close" />
                  </a>
                </div>
              </div>
              <div class="rms-order-total">
                <div class="text-cell-group current-table">
                  <div class="text-cell-item">
                    <label>单桌数量：</label>
                    <span>{{
                      totalData.quantity ? totalData.quantity : 0
                    }}</span>
                  </div>
                  <div class="text-cell-item">
                    <label>单桌金额：</label>
                    <span class="rms-price"
                      >￥{{
                        totalData.totalPrice ? totalData.totalPrice : "0.00"
                      }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>单桌总金额：</label>
                    <span class="rms-price"
                      >￥{{
                        totalData.totalPrice ? totalData.totalPrice : "0.00"
                      }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>单桌折后金额：</label>
                    <span class="rms-price"
                      ><b
                        >￥{{
                          totalData.finalPrice ? totalData.finalPrice : "0.00"
                        }}</b
                      ></span
                    >
                  </div>
                </div>
                <div class="text-cell-group">
                  <div class="text-cell-item">
                    <label>订单总金额：</label>
                    <span class="rms-price"
                      >￥{{ totalData.orderTotalAmount }}</span
                    >
                  </div>
                  <div class="text-cell-item">
                    <label>订单折后金额：</label>
                    <span class="rms-price"
                      ><b>￥{{ totalData.orderFinalAmount }}</b></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="rms-order-actions">
              <div class="rms-order-actions_box">
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="addQuantity"
                  >+1</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="cutQuantity"
                  >-1</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="editQuantity"
                  >数量</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="delRow"
                  >删除</a
                >
                <a
                  :class="{
                    disabled:
                      (!currentSelectedRow._id && !currentSelectedRow.Id) ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="editPrice"
                  >改价</a
                >
                <a
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  @click="setShowFoodCookingMethod"
                  >做法</a
                >

                <a
                  @click="giveFoods"
                  :class="{
                    disabled:
                      currentSelectedRow.Id ||
                      !currentSelectedRow._id ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  >赠送</a
                >
                <a
                  @click="editPack"
                  :class="{
                    disabled:
                      !currentSelectedRow._id ||
                      currentSelectedRow.Id ||
                      !currentSelectedRow.IsPack ||
                      currentSelectedRow.IsUnconfirmed
                  }"
                  >修改套餐</a
                >
              </div>
            </div>
          </div>
        </a-layout-sider>
        <a-layout-content style="padding: 10px 0 0 10px!important;">
          <FoodSelect ref="FoodSelect" @foodClick="addFood" />
          <div class="footer-action-box" style="padding-right:10px;">
            <a-dropdown placement="topCenter">
              <a-button type="primary" style="float:left">打印出品</a-button>
              <a-menu slot="overlay" class="printer-option">
                <a-button type="primary" @click="onPrinter(1)" block
                  >厨单</a-button
                >
                <a-button type="primary" @click="onPrinter(0)" block
                  >总单加厨单</a-button
                >
                <a-dropdown v-model="showFoods" placement="topRight">
                  <a-menu slot="overlay" class="printer-foods-option">
                    打印厨单(指定菜品)
                    <data-grid
                      ref="printerTable"
                      size="small"
                      :columns="orderColumns"
                      v-model="printerFoodList"
                      :pagination="false"
                      :rowSelect="true"
                      :rowTriggerSelect="true"
                      :props="printerTableProps"
                      :locale="{ emptyText: '请选择右侧菜品点菜' }"
                      rowKey="Id"
                    >
                    </data-grid>
                    <a-button type="primary" @click="selectFoods" block
                      >确认打印</a-button
                    >
                  </a-menu>
                  <a-button type="primary" @click="showFoods = true" block
                    >厨单(指定菜品)</a-button
                  >
                </a-dropdown>
              </a-menu>
            </a-dropdown>
            <a-button @click="onSubmit" type="primary">保存</a-button>
            <a-button @click="$router.push({ name: 'RestaurantBookingIndex' })"
              >返回</a-button
            >
          </div>
        </a-layout-content>
      </a-layout>
    </a-spin>
    <a-modal
      :width="755"
      :visible="showMoreFoodCookingMethod"
      title="做法"
      @ok="onMoreFoodCookingMethodSubmit"
      @cancel="showMoreFoodCookingMethod = false"
    >
      <div class="cooking-method all">
        <ul>
          <li
            v-for="item in foodCookingMethodAll"
            :key="item.Id"
            :class="[
              {
                check:
                  foodCookingMethodAllSelectedIds &&
                  foodCookingMethodAllSelectedIds.includes(item.Id)
              }
            ]"
            @click="onFoodCookingMethodAllClick(item)"
          >
            {{ item.Text }}
            <a-icon type="check" class="check-icon" />
          </li>
        </ul>
      </div>
    </a-modal>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { DataGrid } from "@/components/dataGrid";
import promptModal from "@/components/promptModal";
import { cache, accAdd, accMul } from "@/utils/common";
import editFoodPackModal from "./../editFoodPackModal";
import FoodSelect from "./../foodSelect/foodSelect";
import { ReportDetailModal } from "@/views/roommanage/index.js";
import "./../rms.less";
import "./../orderFood.less";
export default {
  components: {
    DataGrid,
    FoodSelect
  },
  data() {
    return {
      user: null,
      orderColumns: [
        {
          title: "菜名",
          dataIndex: "AccountItemName",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "数量",
          dataIndex: "Quantity",
          width: 50,
          align: "center"
        },
        {
          title: "单价",
          dataIndex: "UnitPrice",
          width: 70,
          align: "center"
        },
        {
          title: "金额",
          dataIndex: "TotalPrice",
          width: 70,
          align: "center"
        },
        {
          title: "折扣",
          dataIndex: "DiscountPrice",
          width: 50,
          align: "center"
        },
        {
          title: "核算金额",
          dataIndex: "FinalPrice",
          width: 75,
          align: "center",
          customRender: (text, record) => {
            // icon-daiqueren
            if (record.IsUnconfirmed) {
              return (
                <div>
                  {{ text }}{" "}
                  <a-icon type="schedule" class="un-confirm" title="待确认" />
                </div>
              );
            }
          }
        }
      ],
      orderTableProps: {
        scroll: { x: false, y: "calc(100vh - 371px)" },
        locale: { emptyText: "请选择右侧菜品点菜" }
      },
      printerTableProps: {
        scroll: { x: false, y: "calc(100vh - 320px)" }
      },
      foodSelectWraperWidth: "",
      orderFoodList: [],
      foodClassKey: 0,
      orderData: {},
      tbaleNames: [],
      OrderStatus: "",
      OrderStatusName: "",
      currentTableData: [],
      totalData: {},
      loading: false,
      // 快捷可选的做法，最多4个
      foodCookingMethod: [],
      // 所有可选的做法
      foodCookingMethodAll: [],
      // 已点菜品表格当前选中的行
      currentSelectedRow: {},
      // 是否显示快捷可选做法
      showFoodCookingMethod: false,
      // 是否显示更多做法弹窗
      showMoreFoodCookingMethod: false,
      // 所有做法弹窗中选中的ids
      foodCookingMethodAllSelectedIds: [],
      // IsGiveStatus: false,
      openTableList: [],

      isChooseTable: false,
      tableTitle: "",
      canSettle: true,
      canOrder: true,
      canAntiSettle: false,
      isAntiStatus: false,
      canCancel: true,
      // PrintType: 0,
      printerFoods: [],
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      showFoods: false,
      //是否存在待确认菜品
      hasUnConfirm: false
    };
  },
  computed: {
    gridColumns() {
      const num = Math.round(this.foodSelectWraperWidth / 160);
      let columns = "";
      for (let i = 0; i < num; i++) {
        columns = `${columns} 1fr`;
      }
      return columns;
    },
    tableScroll() {
      let h = "calc(100vh - 371px)";
      if (this.showFoodCookingMethod) {
        h = "calc(100vh - 441px)";
      }
      const orderTable = this.$refs.orderTable;
      if (orderTable && orderTable.$el) {
        const tableBody = orderTable.$el.getElementsByClassName(
          "ant-table-body"
        );
        tableBody[0].style.maxHeight = h;
      }
      return { x: false, y: h };
    },
    printerFoodList() {
      return this.orderFoodList.filter(el => el.Id && !el.IsUnconfirmed);
    }
  },
  created() {
    this.user = cache.get("user");
    this.init();
  },

  methods: {
    accountSettle() {
      this.$refs.AccountSettle.show(this.routeQuery.orderId);
    },
    updateDetail() {
      this.init();
      this.currentSelectedRow = {};
    },
    init() {
      this.isChooseTable = false;
      this.routeQuery = this.$route.query;
      // if (!this.routeQuery.orderId) {
      //   this.$message.error("缺少必要参数");
      //   this.$router.push({
      //     name: "RestaurantIndex"
      //   });
      //   return;
      // }
      // this.fetchOrderData();
      this.orderData = cache.get("booking_info");
      this.fetchCookingMethodData();
    },

    fetchOrderData() {},
    fetchCookingMethodData() {
      this.$post("Common_GetSelect", {
        Types: "CookingMethod"
      }).then(res => {
        this.foodCookingMethodAll = res.Data.CookingMethod;
        this.foodCookingMethod = this.foodCookingMethodAll.filter(
          (p, index) => index < 4
        );
      });
    },
    totalPrice() {
      const totalData = {
        quantity: 0,
        tablePrice: 0,
        totalPrice: 0,
        finalPrice: 0,
        orderTotalAmount: 0,
        orderFinalAmount: 0
      };
      for (let i = 0; i < this.orderFoodList.length; i++) {
        const item = this.orderFoodList[i];
        totalData.quantity = accAdd(totalData.quantity, item.Quantity);
        totalData.totalPrice = accAdd(totalData.totalPrice, item.TotalPrice);
        totalData.finalPrice = accAdd(totalData.finalPrice, item.FinalPrice);
      }
      totalData.orderTotalAmount = totalData.totalPrice;
      totalData.orderFinalAmount = totalData.finalPrice;

      this.totalData = totalData;
    },

    setOrderTableToBottom() {
      const orderTable = this.$refs.orderTable;
      const el = orderTable.$el;
      const tableBody = el.getElementsByClassName("ant-table-body");
      if (tableBody && tableBody.length) {
        setTimeout(() => {
          tableBody[0].scrollTop = tableBody[0].scrollHeight;
        }, 10);
      }
    },
    addFood(item) {
      if (item.IsSoldOut || item.Status == 0) {
        return;
      }
      const isExzist = this.orderFoodList.find(
        el =>
          el.AccountItemId == item.DishId &&
          !el.CookingMethodDesc &&
          !el.CookingMethodIds.length &&
          !el.Id
      );
      if (isExzist) {
        isExzist.Quantity = accAdd(isExzist.Quantity, 1);
        isExzist.TotalPrice = accMul(isExzist.UnitPrice, isExzist.Quantity);
        isExzist.FinalPrice = isExzist.TotalPrice;
        this.currentSelectedRow = isExzist;
        this.$refs.orderTable.setGridData(isExzist);
      } else {
        const row = {
          _id: new Date().getTime() + parseInt(Math.random() * 1000),
          AccountItemId: item.DishId,
          AccountItemName: item.DishName,
          UnitPrice: item.UnitPrice,
          Quantity: 1,
          TotalPrice: item.UnitPrice,
          DiscountPrice: 0,
          FinalPrice: item.UnitPrice,
          CookingMethodIds: [],
          PracticeDesc: "",
          CookingMethodDesc: "",
          IsPack: item.IsPack,
          PackDetails: item.PackDetails
        };
        this.orderFoodList.push(row);
        this.currentSelectedRow = row;
        this.$refs.orderTable.setGridData(row);
        this.setOrderTableToBottom();
      }
      this.showFoodCookingMethod = true;
      this.totalPrice();
    },
    onOrderTableSelectedRow(row) {
      if (!row || row.Id) {
        this.showFoodCookingMethod = false;
      }
      this.currentSelectedRow = row;
    },
    onPrintReport(code, title) {
      if (code) {
        const serverUrl = this.$config.serverUrl;
        let url =
          this.user.ReportUrl +
          "/show?reportid=" +
          code +
          "&orderId=" +
          this.routeQuery.orderId +
          "&url=" +
          serverUrl.substring(
            serverUrl.lastIndexOf("//") + 2,
            serverUrl.length
          ) +
          "&Token=" +
          this.user.Token;
        ReportDetailModal({
          title: title + "信息",
          width: "90%",
          url: url
        });
      }
    },
    selectFoods() {
      this.printerFoods = this.$refs.printerTable.getSelecteds();
      if (!this.printerFoods || !this.printerFoods.length) {
        this.$message.error("请选择打印菜品");
        this.showFoods = true;
        return false;
      }
      this.showFoods = false;
      this.onPrinter(8);
    },
    onPrinter(printType) {
      const { routeQuery, $post, $message } = this;

      const json = {
        OrderId: routeQuery.orderId
      };
      if (printType == 0 || printType == 1) {
        json.PrintType = printType;
      } else {
        const ids = this.printerFoods.map(v => v.Id);
        json.AccountIds = ids;
      }
      $post("RMS_Print", json).then(() => {
        $message.success("打印成功");
        if (this.$refs.printerTable) {
          this.$refs.printerTable.setSelecteds([]);
        }
      });
    },
    onSubmit() {
      const { orderFoodList, $post, orderData } = this;
      const orderList = orderFoodList.filter(el => !el.Id);
      if (orderList && !orderList.length) {
        this.$message.info("请先选择菜品");
        return false;
      }
      const json = {
        ...orderData,
        IsConfirm: true,
        Dishes: orderList
      };
      $post("BookingOrder", json).then(() => {
        cache.remove("booking_info");
        this.$router.push({
          name: "RestaurantOrderList",
          query: {
            activeKey: "0"
          }
        });
      });
    },
    closeCookingMethodBox() {
      this.showFoodCookingMethod = false;
    },
    addMethod() {
      const { currentSelectedRow } = this;

      if (!currentSelectedRow._id) {
        this.$message.warning("请选择菜品");
        return;
      }
      promptModal({
        title: "手写做法",
        type: "a-input",
        inputProps: {
          placeholder: "请输入做法",
          defaultValue: currentSelectedRow.CookingMethodDesc
        },
        submit: val => {
          currentSelectedRow.CookingMethodDesc = val;
          return true;
        }
      });
    },
    onFoodCookingMethodClick(item) {
      const { currentSelectedRow, foodCookingMethodAll } = this;
      if (
        currentSelectedRow &&
        currentSelectedRow.CookingMethodIds &&
        currentSelectedRow.CookingMethodIds.includes(item.Id)
      ) {
        currentSelectedRow.CookingMethodIds = currentSelectedRow.CookingMethodIds.filter(
          p => p != item.Id
        );
      } else if (currentSelectedRow.CookingMethodIds) {
        currentSelectedRow.CookingMethodIds.push(item.Id);
      } else {
        currentSelectedRow.CookingMethodIds = [item.Id];
      }
      currentSelectedRow.PracticeDesc = foodCookingMethodAll
        .filter(p => currentSelectedRow.CookingMethodIds.includes(p.Id))
        .map(p => p.Text)
        .join("");
    },
    onFoodCookingMethodAllClick(item) {
      const { foodCookingMethodAllSelectedIds } = this;
      if (foodCookingMethodAllSelectedIds.includes(item.Id)) {
        this.foodCookingMethodAllSelectedIds = foodCookingMethodAllSelectedIds.filter(
          p => p != item.Id
        );
      } else {
        foodCookingMethodAllSelectedIds.push(item.Id);
      }
    },
    openMoreFoodCookingMethodModal() {
      let { currentSelectedRow } = this;
      this.showMoreFoodCookingMethod = true;
      if (currentSelectedRow.CookingMethodIds) {
        this.foodCookingMethodAllSelectedIds = cloneDeep(
          currentSelectedRow.CookingMethodIds
        );
      } else {
        this.foodCookingMethodAllSelectedIds = [];
      }
    },
    // 更多菜品做法弹窗提交
    onMoreFoodCookingMethodSubmit() {
      const {
        currentSelectedRow,
        foodCookingMethodAllSelectedIds,
        foodCookingMethodAll
      } = this;
      currentSelectedRow.CookingMethodIds = foodCookingMethodAllSelectedIds;
      this.showMoreFoodCookingMethod = false;
      currentSelectedRow.PracticeDesc = foodCookingMethodAll
        .filter(p => currentSelectedRow.CookingMethodIds.includes(p.Id))
        .map(p => p.Text)
        .join("");
    },
    // 显示菜品做法快捷选择框
    setShowFoodCookingMethod(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      this.showFoodCookingMethod = true;
      this.setOrderTableToBottom();
    },
    //赠送菜品
    giveFoods() {
      // this.IsGiveStatus = true;
      // this.setGiveStatus(true);
      const { currentSelectedRow } = this;
      if (currentSelectedRow) {
        currentSelectedRow.UnitPrice = 0;
        currentSelectedRow.TotalPrice = 0;
        currentSelectedRow.DiscountPrice = 0;
        currentSelectedRow.FinalPrice = 0;
      } else {
        this.$message.warning("请选择赠送菜品");
      }
      this.totalPrice();
    },
    // 增加菜品数量
    addQuantity(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      currentSelectedRow.Quantity = currentSelectedRow.Quantity + 1;
      currentSelectedRow.TotalPrice = accMul(
        currentSelectedRow.UnitPrice,
        currentSelectedRow.Quantity
      );
      currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;
      this.totalPrice();
    },
    // 减少菜品数量
    cutQuantity(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      const that = this;
      if (currentSelectedRow.Quantity == 1) {
        this.$confirm({
          title: "你确认删除选中菜品吗?",
          onOk() {
            that.orderFoodList = that.orderFoodList.filter(
              p => p._id !== currentSelectedRow._id
            );
            that.showFoodCookingMethod = false;
            that.totalPrice();
          },
          onCancel() {}
        });
      } else {
        currentSelectedRow.Quantity = currentSelectedRow.Quantity - 1;
        currentSelectedRow.TotalPrice = accMul(
          currentSelectedRow.UnitPrice,
          currentSelectedRow.Quantity
        );
        currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;
        this.totalPrice();
      }
    },
    //删除
    delRow(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      this.orderFoodList = this.orderFoodList.filter(
        p => p._id !== currentSelectedRow._id
      );
      this.showFoodCookingMethod = false;
      if (this.orderFoodList && this.orderFoodList.length) {
        this.currentSelectedRow = this.orderFoodList[
          this.orderFoodList.length - 1
        ];
        this.$refs.orderTable.setGridData(this.currentSelectedRow);
        if (!this.currentSelectedRow.Id) {
          this.showFoodCookingMethod = true;
        }
      } else {
        this.currentSelectedRow = {};
        this.showFoodCookingMethod = false;
      }
      this.setOrderTableToBottom();
      this.totalPrice();
    },
    // 改价
    editPrice(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow, $post } = this;
      if (
        this.openTableList &&
        this.openTableList.length > 1 &&
        currentSelectedRow.Id
      ) {
        this.$refs.ReturnDish.show(
          currentSelectedRow,
          this.openTableList,
          "editPrice"
        );
      } else {
        promptModal({
          title: "修改价格",
          type: "a-input-number",
          inputProps: {
            placeholder: "请输入价格",
            defaultValue: currentSelectedRow.UnitPrice
          },
          submit: val => {
            if (currentSelectedRow.Id) {
              $post("RMS_EditPriceAsync", {
                AccountId: currentSelectedRow.Id,
                UnitPrice: val
              }).then(() => {
                this.setPrice(val);
              });
            } else {
              this.setPrice(val);
            }
            return true;
          }
        });
      }
    },
    setPrice(val) {
      const { currentSelectedRow } = this;
      currentSelectedRow.UnitPrice = val;
      currentSelectedRow.TotalPrice = accMul(
        currentSelectedRow.UnitPrice,
        currentSelectedRow.Quantity
      );
      currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;

      this.totalPrice();
    },
    // 修改数量
    editQuantity(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const { currentSelectedRow } = this;
      promptModal({
        title: "修改数量",
        type: "a-input-number",
        inputProps: {
          placeholder: "请输入数字",
          defaultValue: currentSelectedRow.Quantity
        },
        submit: val => {
          currentSelectedRow.Quantity = val;
          currentSelectedRow.TotalPrice = accMul(
            currentSelectedRow.UnitPrice,
            currentSelectedRow.Quantity
          );
          currentSelectedRow.FinalPrice = currentSelectedRow.TotalPrice;
          this.totalPrice();
          return true;
        }
      });
    },
    editPack(e) {
      if (e.target.getAttribute("class").indexOf("disabled") > -1) {
        return false;
      }
      const that = this;
      const { currentSelectedRow } = this;
      editFoodPackModal({
        data: currentSelectedRow.PackDetails,
        submit: data => {
          that.currentSelectedRow.PackDetails = data;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped></style>
